<template>
  <b-card class="mb-3">
    <b-row>
      <b-col md="4" sm="12">
        <b-form-group label="Data Inicial" label-for="commissions-from-date">
          <b-form-datepicker
            id="commissions-from-date"
            v-model="form.fromDate"
            placeholder="Selecione uma data"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }"
            locale="pt-BR"
          />
        </b-form-group>
      </b-col>

      <b-col md="4" sm="12">
        <b-form-group label="Data Final" label-for="commissions-to-date">
          <b-form-datepicker
            id="commissions-to-date"
            v-model="form.toDate"
            placeholder="Selecione uma data"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }"
            locale="pt-BR"
          />
        </b-form-group>
      </b-col>

      <b-col md="4" sm="12" class="align-self-end">
        <div class="action-buttons">
          <b-button variant="secondary" @click="handleClear">
            <span class="fas fa-times mr-2" />Limpar
          </b-button>
          <b-button variant="primary" @click="handleFilter">
            <span class="fas fa-filter mr-2" />Filtrar
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'CommissionsReportFilter',
  props: {
    value: {
      type: Object,
      default: () => ({ fromDate: null, toDate: null })
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    handleFilter() {
      this.$emit('filter')
    },
    handleClear() {
      this.form = { fromDate: null, toDate: null }
      this.$emit('filter')
    }
  }
}
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 0.5rem;
}

@media (max-width: 767.98px) {
  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .btn {
    width: 100%;
  }
}
</style>
